import React, { useRef, useState, useEffect } from "react";
import "../styles/hero.css";
import heroVideo from "../assets/hero-video-small.mp4";

const Hero = () => {
  const videoRef = useRef(null);
  const [hasInteracted, setHasInteracted] = useState(false);
  const [showOverlay, setShowOverlay] = useState(true);

  // PLAY / PAUSE BASED ON VISIBILITY
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!hasInteracted) return;

        if (entry.isIntersecting) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      },
      { threshold: 0.5 }
    );

    observer.observe(video);

    return () => observer.disconnect();
  }, [hasInteracted]);

  // USER STARTS VIDEO WITH SOUND
  const handleStart = () => {
    const video = videoRef.current;
    if (!video) return;

    video.muted = false;
    video.volume = 1;
    video.play().catch(() => {});
    setHasInteracted(true);
    setShowOverlay(false);
  };

  // CLICK TOGGLE PLAY / PAUSE
  const handleVideoClick = () => {
    const video = videoRef.current;
    if (!video || !hasInteracted) return;

    if (video.paused) {
      video.play().catch(() => {});
    } else {
      video.pause();
    }
  };

  return (
    <section className="hero-section" id="hero">
      <div className="container hero-container mt-4">
        <h1 className="hero-title">
          Válj szabad nővé,
          <br /> aki saját kezébe veszi a jövőjét!
        </h1>

        <p className="hero-sub">
          Nézd meg a videót, és tudd meg, hogyan teremthetsz magadnak
          <strong> független, szabad és stabil életet</strong> – akár teljesen a
          nulláról.
        </p>

        <p className="hero-sub-2">
          A módszerem <strong>20+ éve működik</strong>. Nézd meg, hogyan.
        </p>

        <div className="hero-video-wrapper">
          <video
            ref={videoRef}
            className="hero-video"
            muted
            playsInline
            preload="metadata"
            controls={false}
            onClick={handleVideoClick}
          >
            <source src={heroVideo} type="video/mp4" />
          </video>

          {showOverlay && (
            <div className="video-overlay-corner" onClick={handleStart}>
              <div className="corner-inner">
                <span className="corner-text">Videó indítása hanggal</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Hero;
